import React from 'react';

const IconMedium = () => (
  <svg xmlns="http://www.w3.org/2000/svg">
    <title>Medium</title>
    <path
      d="M 2.1345001,6.3531997 C 2.1570001,6.098712 2.07225,5.8476749 1.9072501,5.6768661 L 0.22725001,3.3476561 V 3 H 5.44575 L 9.4792504,13.175197 13.02525,3 H 18 V 3.3476561 L 16.562999,4.9323816 C 16.43925,5.0410781 16.37775,5.2196509 16.40325,5.3964983 V 17.040823 c -0.0255,0.175985 0.036,0.354557 0.159749,0.463254 l 1.403251,1.584725 v 0.347657 H 10.907249 V 19.088802 L 12.3615,17.465257 c 0.142499,-0.163908 0.142499,-0.212217 0.142499,-0.463254 V 7.590269 L 8.46225,19.398501 H 7.9162501 L 3.2100001,7.590269 v 7.914138 c -0.038999,0.332128 0.056999,0.667707 0.2602499,0.907529 l 1.8907501,2.638046 v 0.348519 H 0 v -0.348519 l 1.8907499,-2.638046 c 0.2025,-0.240685 0.2925001,-0.577989 0.2437502,-0.907529 z"
      style={{ strokeWidth: 0.99999988 }}
    />
  </svg>
);

export default IconMedium;
